<template>
  <div>
    <a-select
    v-model="selectTenant"
    show-search
    placeholder="请选择服务商"
    class="severs_select"
    :disabled="disabled"
    mode="multiple"
    dropdown-class-name="dropdown"
    :dropdown-match-select-width="false"
    :filter-option="filterOption"
    :not-found-content="null"
    @change="handleChange"
  >
    <a-select-option v-for="item in TenantList" :key="item.id">
      {{ item.ownerTenantName }}<span class="customer_style">({{item.customerName}})</span>
    </a-select-option>
  </a-select>
  </div>
</template>

<script>
import {getSignType} from '@/api/enterprise/authentication'
import { mapMutations } from 'vuex'

  export default {
  name:'ServiceSelect',
  props:{
    isDefaultSelect:{
      type:Boolean,
      default:()=>(false)
    },
    value:{
      type:Array,
      default:()=> ([])
    },
    onlySelect:{
      type:Boolean,
      default:()=>(true)
    },
    disabled:{
      type:Boolean,
      default:()=>(false)
    }
  },
    data(){
      return {
        TenantList:[],
        selectTenant: undefined,
      }
    },
    watch: {
      value(val) {
        this.selectTenant=val
      }
    },
    created(){
      this.fetchData()
    },
    methods:{
      ...mapMutations('user', ['SET_USER_DATA']),
      handleReset(){
        this.selectTenant=undefined
      },
      async fetchData(value){
        const {customers} =this.$store.state.user
        const params=customers.map(item=>item.customerId)
        const data={
          ids:params,
          ownerTenantNameLike:value,
        }
        const res = await getSignType(data)
        this.TenantList = res
        // if(this.value) {
        //   this.selectTenant=this.value
        // }
      },
      filterOption(input, option) {
        return (
          option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
        );
      },
      handleChange(value) {
        const select = this.TenantList.filter(item => value.includes(item.id))
        this.$emit('change',select)
      },
    }
  }
</script>

<style lang="less" scoped>
.customer_style {
  font-size: 14px;
  margin-left: 10px;
  color: #ccc;
}
.dropdown {
width: 500px;
}
</style>